import type { ReactElement } from 'react';

import { MemoryBrowserPage } from '../features/memory/pages/MemoryBrowserPage.js';

export default function MemoryPage(): ReactElement {
  return <MemoryBrowserPage />;
}
